export const SITE_ORIGIN = 'https://mustimpress.com';

export function projectImage(slug, file) {
  return `/assets/images/projects/${slug}/${file}`;
}

export function projectVideo(slug, file) {
  return `/assets/videos/projects/${slug}/${file}`;
}

export const navItems = [
  { label: 'Home', to: '/?section=home' },
  { label: 'About', to: '/?section=about' },
  { label: 'Services', to: '/?section=services' },
  { label: 'Work', to: '/?section=work' },
  { label: 'Contact', to: '/?section=footer' },
];

export const site = {
  name: 'Must Impress',
  person: 'Marc Hudson',
  jobTitle: 'Senior Product/UI Designer & Developer',
  seo: {
    title: 'Marc Hudson, Senior Product/Visual Designer & Developer | mustimpress.com',
    description: 'Senior Product/Visual Designer & Developer with over 20 years of experience across startups, international brands, government agencies and everything in between.',
    path: '/',
  },
  linkedin: 'https://www.linkedin.com/in/marchudson2',
  home: {
    hero: {
      context: 'Marc Hudson',
      title: 'Senior Product/UI Designer & Developer',
      intro: 'I design distinctive, intuitive digital products and bring them to life – working across product strategy, visual/UI design and front-end web/app development.',
      video: '/assets/videos/portrait.mp4',
    },
    about: {
      title: 'What a ride.',
      intro: "I've worked globally for over 20 years with startups, international brands, government agencies and everything in between.",
      stats: [
        { value: 22, label: 'years' },
        { value: 4, label: 'continents' },
        { value: 100, suffix: '+', label: 'clients' },
        { value: 73, label: 'industries' },
      ],
    },
    services: {
      context: 'What I do',
      title: 'From idea to impact.',
      intro: 'I work across brand and product strategy, creative and user experience, and development – helping turn complex ideas into clear, intuitive and distinctive digital products.',
      items: [
        {
          title: 'Strategy & Experience',
          items: [
            'Strategy and definition',
            'Discovery and concept development',
            'User journeys and flows',
            'Information architecture',
            'Rapid wireframing and prototyping',
            'UX and product reviews',
          ],
        },
        {
          title: 'Brand & creative',
          items: [
            'Brand identity & guidelines',
            'UI & visual design',
            'Design System development',
            'Campaign creative & assets',
            'Print & physical experiences',
          ],
        },
        {
          title: 'Development',
          items: [
            'React+Typescript Web/app dev.',
            'Rapid in-browser feature design',
            'Service integrations',
            'Performance optimisation',
            'QA and testing',
          ],
        },
      ],
    },
    clients: {
      title: 'Some happy clients',
      logos: [
        { src: '/assets/images/clients/logo-unilever.png', alt: 'Unilever' },
        { src: '/assets/images/clients/logo-bentley.png', alt: 'Bentley' },
        { src: '/assets/images/clients/logo-worldpay.png', alt: 'Worldpay' },
        { src: '/assets/images/clients/logo-ausgov.png', alt: 'Australian Government' },
        { src: '/assets/images/clients/logo-thales.png', alt: 'Thales' },
        { src: '/assets/images/clients/logo-aa.png', alt: 'AA' },
        { src: '/assets/images/clients/logo-sky.png', alt: 'Sky' },
        { src: '/assets/images/clients/logo-astrazeneca.png', alt: 'AstraZeneca' },
        { src: '/assets/images/clients/logo-jameson.png', alt: 'Jameson' },
        { src: '/assets/images/clients/logo-accenture.png', alt: 'Accenture' },
        { src: '/assets/images/clients/logo-coral.png', alt: 'Coral' },
        { src: '/assets/images/clients/logo-absolut.png', alt: 'Absolut' },
      ],
    },
    work: {
      featured: {
        slug: 'bentley',
        title: 'Bentley Motors',
        intro: 'An inspiring e-commerce experience for a global icon.',
        tags: ['UX', 'UI'],
      },
    },
  },
  footer: {
    title: "Let's talk",
    intro: "Whatever you're building...",
    body: "If you think I could add something to your project, I'd love to hear about it.",
    cta: 'Get in touch',
    copyright: `© ${new Date().getFullYear()} Marc Hudson - Must Impress.`,
  },
  contact: {
    title: 'Contact',
    intro: "Got something in the works? I'd love to hear about it.",
    caseIntro: "Whatever you're building, I'd love to hear about it.",
  },
};

const heroScroll = {
  'data-intro-trigger': '#case-study',
  'data-intro-motion-span-vh': '100',
  'data-intro-start-y-vh': '77',
  'data-intro-end-y-vh': '-20',
  'data-intro-trigger-lead-vh': '0',
  'data-intro-fade-in-start': '0',
  'data-intro-fade-in-end': '0.05',
  'data-intro-fade-out-start': '0.6',
  'data-intro-fade-out-end': '0.9',
  'data-intro-opacity-start': '1',
  'data-intro-opacity-end': '0',
  'data-intro-blur-px': '10',
};

const heroFixed = {
  'data-content-fixed-fade-in-start': '0.05',
  'data-content-fixed-fade-in-end': '0.1',
  'data-content-fixed-fade-out-start': '0.5',
  'data-content-fixed-fade-out-end': '0.9',
  'data-content-fixed-opacity-start': '0',
  'data-content-fixed-opacity-end': '0',
};

const introScroll = {
  'data-intro-trigger': '#case-intro',
  'data-intro-motion-span-vh': '100',
  'data-intro-start-y-vh': '80',
  'data-intro-end-y-vh': '-20',
  'data-intro-trigger-lead-vh': '0',
  'data-intro-fade-in-start-offset': '-6rem',
  'data-intro-fade-in-end-offset': '1rem',
  'data-intro-fade-out-start-offset': '5rem',
  'data-intro-fade-out-end-offset': '25svh',
  'data-intro-opacity-start': '0',
  'data-intro-opacity-end': '0',
  'data-intro-blur-px': '10',
  'data-intro-pause-for': '80',
  'data-intro-pause-at': 'bottom',
  'data-intro-pause-offset': '1rem',
};

const introFixed = {
  'data-content-fixed-fade-in-start-offset': '-4rem',
  'data-content-fixed-fade-in-end-offset': '1rem',
  'data-content-fixed-fade-out-start-offset': '6rem',
  'data-content-fixed-fade-out-end-offset': '40svh',
  'data-content-fixed-opacity-start': '0',
  'data-content-fixed-opacity-end': '0',
};

const explainScroll = {
  'data-intro-motion-span-vh': '100',
  'data-intro-start-y-vh': '90',
  'data-intro-end-y-vh': '0|-20',
  'data-intro-trigger-lead-vh': '0',
  'data-intro-fade-in-start': '0',
  'data-intro-fade-in-end': '0.02|0.05',
  'data-intro-fade-out-start': '0.3|0.45|0.5',
  'data-intro-fade-out-end': '0.5|0.55|0.8',
  'data-intro-opacity-start': '0',
  'data-intro-opacity-end': '0',
  'data-intro-blur-px': '10',
  'data-intro-pause-for': '500|150',
  'data-intro-pause-at': 'bottom',
};

const explainFixed = {
  'data-content-fixed-fade-in-start': '0.4|0',
  'data-content-fixed-fade-in-end': '0.5|0',
  'data-content-fixed-fade-out-start': '0.9|0.5',
  'data-content-fixed-fade-out-end': '1|0.9',
  'data-content-fixed-opacity-start': '0',
  'data-content-fixed-opacity-end': '0',
};

const explainThemeScroll = {
  'data-scroll-y-start-vh': '0',
  'data-scroll-y-span-vh': '100',
  'data-scroll-y-start-offset': '0',
  'data-scroll-y-reverse': 'true',
};

function explainSection(id, title, insights, video, extras = {}) {
  return {
    id,
    title,
    insights,
    video,
    scroll: { ...explainScroll, 'data-intro-trigger': `#${id}` },
    fixed: explainFixed,
    themeScroll: extras.themeScroll !== false ? explainThemeScroll : null,
    videoClass: extras.videoClass || '',
    dividerStyle: extras.dividerStyle || null,
  };
}

export const projects = [
  {
    slug: 'bentley',
    title: 'Bentley Motors',
    path: '/projects/bentley',
    published: true,
    featured: true,
    seo: {
      title: 'Bentley Motors | mustimpress.com',
      description: 'An inspiring e-commerce experience for a global icon.',
    },
    brand: {
      primary: '#394D45',
      foreground: '#FFF',
      introColor: 'var(--color-tertiary-a)',
      introHighlight: 'var(--color-white)',
      explainColor: 'var(--color-white)',
      explainHighlight: 'var(--color-white)',
      hue: 0,
    },
    tags: ['UX', 'UI', 'Prototype'],
    caseTags: ['UX', 'UI', 'Prototyping'],
    homeTags: ['UX', 'UI', 'Prototype'],
    intro: 'An inspiring e-commerce experience for a global icon.',
    cover: {
      tile: 'hero',
      fg: projectImage('bentley', 'cover-fg.png'),
      bg: projectImage('bentley', 'cover-bg.jpg'),
    },
    overview: {
      context: 'Overview',
      title: 'UX, UI & Prototyping',
      body: "More than just a new look, the redesign transformed how customers experienced Bentley online – delivering a seamless digital experience, a reimagined model configurator and a personalised sales journey that deepened engagement from discovery through to delivery.",
      logo: projectImage('bentley', 'logo-bentley.png'),
    },
    hero: {
      theme: {
        'data-bg': 'var(--color-brand-primary)',
        'data-color': 'var(--color-white)',
        'data-highlight': 'var(--color-white)',
        'data-highlight-color': 'var(--color-secondary)',
        'data-start': 'complete',
        'data-scroll-y-start-vh': '0',
        'data-scroll-y-span-vh': '80',
        'data-scroll-y-start-offset': '40',
        'data-scroll-y-reverse': 'true',
        'data-header-fade': 'true',
      },
      scroll: heroScroll,
      fixed: heroFixed,
    },
    introMotion: {
      scroll: introScroll,
      fixed: introFixed,
    },
    explain: [
      explainSection(
        'case-page0',
        'Objectives',
        [
          { title: 'Elevate the digital brand', body: "Translate Bentley's refreshed identity into a distinctive digital experience that retained the marque's heritage while appealing to changing customer demographics, tastes and expectations." },
          { title: 'Support the customer journey', body: 'Make it easier for customers to explore the range, understand model differences and find the information they needed—wherever they entered the website and however close they were to making a decision.' },
          { title: 'Generate qualified enquiries', body: 'Create clearer routes from inspiration to action, helping interested customers find a retailer, request information, arrange a test drive or begin configuring a vehicle.' },
        ],
        { src: projectVideo('bentley', 'continental.mp4'), className: 'square' },
      ),
      explainSection(
        'case-page1',
        'Key insights',
        [
          { title: 'Luxury e-commerce', body: "The brand required a premium feel, but users also needed practical information fast – model differences, features, specifications, availability, and next-step actions. The experience couldn't behave like a brand film when users are trying to make a considered purchase decision." },
          { title: 'Landing pages', body: "Users don't move neatly from homepage to model pages to enquiry. Many were entering deep in the journey through search, campaign links, or specific vehicle pages, so every key page needed to work as a strong landing page in its own right." },
          { title: 'Personalisation', body: 'A global automotive site needs one clear design system, but local markets often have different content priorities, regulatory needs, CTAs, and ownership journeys. The solution had to balance central brand control with enough flexibility for regional variation.' },
        ],
        { src: projectVideo('bentley', 'interior.mp4'), className: 'square' },
      ),
    ],
    outcomes: [
      {
        index: '01',
        reverse: true,
        title: 'Reaching a new generation',
        body: 'The redesign established a contemporary new digital expression for Bentley, reflecting its refreshed identity while appealing to new markets and changing customer preferences.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-5/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-7/12 content-center content-visible relative',
        media: {
          containerClass: 'device-container iphone-reveal center',
          devices: [
            {
              type: 'iphone',
              wrapperClass: 'iphone iphone-reveal-static z-2',
              screenClass: 'no-safe-area',
              images: [{ src: projectImage('bentley', 'mobile-home--cropped.jpg') }],
            },
            {
              type: 'iphone',
              wrapperClass: 'iphone iphone-reveal-left',
              screenStyle: { '--safe-area-bg': '#000' },
              images: [{ src: projectImage('bentley', 'mobile-menu.jpg') }],
            },
          ],
        },
      },
      {
        index: '02',
        title: 'A more intuitive configurator',
        body: 'The redesigned model configurator made it easier and more engaging for customers to explore options, compare features and create a Bentley tailored to their individual tastes.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-6/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-6/12 content-center',
        scroll: {
          'data-scroll-y-start-vh': '0',
          'data-scroll-y-span-vh': '100',
          'data-scroll-y-start-offset': '-10rem|0',
          'data-scroll-y-reverse': 'true',
          'data-scroll-y-factor': '1.5|1',
        },
        media: {
          containerClass: 'device-container',
          devices: [
            {
              type: 'ipad',
              wrapperClass: 'ipad animate-screen',
              images: [{ src: projectImage('bentley', 'desktop-configurator.jpg') }],
            },
          ],
        },
      },
      {
        index: '03',
        title: 'A more connected sales journey',
        body: 'A new Enquire to Buy portal introduced live chat, connecting prospective customers directly with Bentley representatives. This provided a more immediate route to support and more qualified enquiries.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-6/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-6/12 content-center',
        scroll: {
          'data-scroll-y-start-vh': '0',
          'data-scroll-y-span-vh': '100',
          'data-scroll-y-start-offset': '-10rem|0',
          'data-scroll-y-reverse': 'true',
          'data-scroll-y-factor': '1.5|1.3',
        },
        media: {
          containerClass: 'device-container',
          devices: [
            {
              type: 'ipad',
              wrapperClass: 'ipad slideshow',
              wrapperStyle: { '--slides': 3 },
              images: [
                { src: projectImage('bentley', 'desktop-enquire3.jpg'), style: { '--slide': 0 } },
                { src: projectImage('bentley', 'desktop-enquire2.jpg'), style: { '--slide': 1 } },
                { src: projectImage('bentley', 'desktop-enquire1.jpg'), style: { '--slide': 2 } },
              ],
            },
          ],
        },
      },
      {
        index: '04',
        reverse: true,
        title: 'An enhanced ownership journey',
        body: 'A new build progress experience kept customers informed and connected as their Bentley was created, extending the digital journey from purchase through to delivery.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-6/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-6/12 content-center',
        scroll: {
          'data-scroll-y-start-vh': '-12|-30|-10',
          'data-scroll-y-span-vh': '100',
          'data-scroll-y-start-offset': '10|0',
          'data-scroll-y-reverse': 'true',
          'data-scroll-y-factor': '1.2|1.3|1.2',
        },
        media: {
          containerClass: 'device-container',
          devices: [
            {
              type: 'iphone',
              wrapperClass: 'iphone animate-screen',
              screenStyle: { '--safe-area-bg': '#FFF' },
              images: [{ src: projectImage('bentley', 'mobile-progress.jpg') }],
            },
          ],
        },
      },
    ],
  },
  {
    slug: 'picnic',
    title: 'Picnic',
    path: '/projects/picnic',
    published: true,
    seo: {
      title: 'Picnic | mustimpress.com',
      description: 'Picnic is the dating app for the modern age. Matching on lifestyle, not selfies.',
    },
    brand: {
      primary: '#E9F27C',
      foreground: '#233B66',
      introColor: 'var(--color-brand-foreground)',
      introHighlight: 'var(--color-black)',
      explainColor: 'var(--color-brand-foreground)',
      explainHighlight: 'var(--color-black)',
      hue: 10,
    },
    tags: ['Product Design', 'Branding', 'UI', 'App Dev'],
    caseTags: ['Branding', 'Product Design', 'UI', 'App Dev'],
    homeTags: ['Product Design', 'Branding', 'UI', 'App Dev'],
    intro: 'An innovative dating app for online dating 2.0.',
    cover: {
      tile: 'device',
      fg: projectImage('picnic', 'cover-fg.png'),
      bg: projectImage('picnic', 'cover-bg.jpg'),
      alt: 'Picnic',
      device: {
        type: 'iphone',
        screenClass: 'no-safe-area',
        images: [{ src: projectImage('picnic', 'mobile-welcome.jpg') }],
      },
    },
    overview: {
      context: 'Overview',
      title: 'Product Design, Branding, UI & App Dev',
      body: 'Picnic takes a fresh approach to dating apps, designed to make meeting like-minded people feel more natural, engaging and enjoyable. I shaped the experience from end to end, leading the branding, UX and UI design, as well as the front-end app development itself.',
      logo: projectImage('picnic', 'logo-picnic.png'),
    },
    hero: {
      theme: {
        'data-bg': 'var(--color-brand-primary)',
        'data-color': 'var(--color-brand-foreground)',
        'data-highlight': 'var(--color-white)',
        'data-highlight-color': 'var(--color-secondary)',
        'data-start': 'complete',
        'data-scroll-y-start-vh': '0',
        'data-scroll-y-span-vh': '100',
        'data-scroll-y-start-offset': '40',
        'data-scroll-y-reverse': 'true',
        'data-header-fade': 'true',
      },
      scroll: heroScroll,
      fixed: heroFixed,
    },
    introMotion: {
      scroll: introScroll,
      fixed: introFixed,
    },
    explain: [
      explainSection(
        'case-page0',
        'Objectives',
        [
          { title: 'More than a profile', body: 'Create a richer dating experience where personality, interests and lifestyle can shine through, giving people more meaningful ways to discover each other and connect beyond appearances.' },
          { title: 'More natural connections', body: 'Move beyond the binary match-or-dismiss model, creating more natural opportunities to interact, start conversations and build connections without an immediate judgement.' },
          { title: 'A more balanced experience', body: 'Create a fairer, more balanced experience for everyone, reducing the dynamics that can make dating apps feel one-sided and bringing interactions closer to how people meet naturally offline.' },
        ],
        { src: projectVideo('picnic', 'woods.mp4'), className: 'square' },
        { dividerStyle: { '--divider-bg': 'var(--color-brand-foreground)', '--divider-opacity': 0.2 } },
      ),
      explainSection(
        'case-page1',
        'Key insights',
        [
          { title: 'Misaligned incentives', body: 'Most dating apps rely on subscriptions and prolonged engagement. Picnic needed to break that cycle with an experience designed to be fair, efficient and genuinely focused on helping people connect.' },
          { title: 'Standing out is essential', body: "In a crowded and highly established market, another familiar dating experience wouldn't be enough. Picnic needed a distinctive proposition, identity and experience that felt genuinely new." },
          { title: 'Dating app fatigue', body: 'Ghosting, endless swiping, repetitive small talk and few meaningful connections have left many people fatigued by dating apps. Picnic needed to make the experience fun and rewarding again.' },
        ],
        { src: projectVideo('picnic', 'hands.mp4'), className: 'square' },
        { dividerStyle: { '--divider-bg': 'var(--color-brand-foreground)', '--divider-opacity': 0.2 } },
      ),
    ],
    outcomes: [
      {
        index: '01',
        title: 'A more engaging experience',
        body: 'Playful interactions and a more dynamic approach to discovery helped make using the app feel engaging and enjoyable, rather than purely transactional.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-6/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-6/12 content-center content-visible relative',
        media: {
          containerClass: 'device-container iphone-reveal center',
          devices: [
            {
              type: 'iphone',
              wrapperClass: 'iphone iphone-reveal-static z-2',
              screenClass: 'no-safe-area',
              images: [{ src: projectImage('picnic', 'mobile-welcome.jpg') }],
            },
            {
              type: 'iphone',
              wrapperClass: 'iphone iphone-reveal-left slide',
              screenClass: 'no-safe-area',
              ui: [
                { className: 'add-button', src: projectImage('picnic', 'mobile-feed-addbutton.png') },
                { className: 'footer', src: projectImage('picnic', 'mobile-menubar.jpg') },
              ],
              images: [{ src: projectImage('picnic', 'mobile-feed--moment.jpg') }],
            },
          ],
        },
      },
      {
        index: '02',
        reverse: true,
        title: 'Beyond first impressions',
        body: 'The Feed was designed to go beyond profiles and present lifestyle, personality and interests, giving people more to discover and engage with than just selfies alone.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-6/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-6/12 content-center',
        scroll: {
          'data-scroll-y-start-vh': '-25|-30|-10|-30',
          'data-scroll-y-span-vh': '100',
          'data-scroll-y-start-offset': '0',
          'data-scroll-y-reverse': 'true',
          'data-scroll-y-factor': '1.4|1.3|1.6',
        },
        media: {
          containerClass: 'device-container',
          devices: [
            {
              type: 'iphone',
              wrapperClass: 'iphone animate-screen',
              screenClass: 'no-safe-area',
              ui: [
                { className: 'add-button', src: projectImage('picnic', 'mobile-feed-addbutton.png') },
                { className: 'footer', src: projectImage('picnic', 'mobile-menubar.jpg') },
              ],
              images: [{ src: projectImage('picnic', 'mobile-feed.jpg') }],
            },
          ],
        },
      },
      {
        index: '03',
        title: 'More natural relationship building',
        body: 'New ways to interact gave connections room to develop naturally, without relying on forced introductions or repetitive small talk.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-6/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-6/12 content-center',
        scroll: {
          'data-scroll-y-start-vh': '-12|-30|-10|-30',
          'data-scroll-y-span-vh': '100',
          'data-scroll-y-start-offset': '10|0',
          'data-scroll-y-reverse': 'true',
          'data-scroll-y-factor': '1.3|1.3|1.4',
        },
        media: {
          containerClass: 'device-container',
          devices: [
            {
              type: 'iphone',
              wrapperClass: 'iphone animate-screen horizontal-element',
              wrapperStyle: { '--offset-y': '-820px', '--scroll-element-width': '500%' },
              screenClass: 'no-safe-area',
              horizontal: { className: 'footer', src: projectImage('picnic', 'mobile-chat-footer.jpg') },
              images: [{ src: projectImage('picnic', 'mobile-chat.jpg') }],
            },
          ],
        },
      },
      {
        index: '04',
        reverse: true,
        title: 'No more endless swiping',
        body: 'Replacing the monotonous swipe-to-dismiss mechanic allowed people to explore profiles more freely, without forcing an immediate decision on every person they encountered.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-5/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-7/12 content-center content-visible relative',
        media: {
          containerClass: 'device-container iphone-reveal center',
          devices: [
            {
              type: 'iphone',
              wrapperClass: 'iphone iphone-reveal-static z-2',
              screenClass: 'no-safe-area',
              ui: [{ className: 'footer', src: projectImage('picnic', 'mobile-menubar--discover.jpg') }],
              images: [{ src: projectImage('picnic', 'mobile-discover1.jpg') }],
            },
            {
              type: 'iphone',
              wrapperClass: 'iphone iphone-reveal-left',
              screenClass: 'no-safe-area',
              ui: [{ className: 'footer', src: projectImage('picnic', 'mobile-menubar--discover.png') }],
              images: [{ src: projectImage('picnic', 'mobile-discover2.jpg') }],
            },
          ],
        },
      },
    ],
  },
  {
    slug: 'onmo',
    title: 'Onmo',
    path: '/projects/onmo',
    published: true,
    seo: {
      title: 'Onmo | mustimpress.com',
      description: 'A modern online credit card experience for a disruptive fintech startup',
    },
    brand: {
      primary: '#FC4C02',
      foreground: '#222',
      introColor: 'var(--color-brand-foreground)',
      introHighlight: 'var(--color-white)',
      explainColor: 'var(--color-brand-foreground)',
      explainHighlight: 'var(--color-white)',
      hue: 20,
    },
    tags: ['UI', 'Design System'],
    caseTags: ['UI', 'Design System'],
    homeTags: ['UI', 'Design System'],
    intro: 'A modern online credit card experience for a disruptive fintech startup.',
    cover: {
      tile: 'device',
      fg: projectImage('onmo', 'cover-fg.png'),
      bg: projectImage('onmo', 'cover-bg.jpg'),
      alt: 'Onmo',
      device: {
        type: 'iphone',
        screenClass: 'no-safe-area',
        images: [{ src: projectImage('onmo', 'mobile-account.jpg') }],
      },
    },
    overview: {
      context: 'Overview',
      title: 'UI Design & Design System',
      body: 'I led the UI design for Onmo, bringing a refreshed brand identity across the app and web experience. I also created a scalable design system to improve consistency and enable new products and features to be built with maximum efficiency.',
      logo: projectImage('onmo', 'logo-onmo.png'),
    },
    hero: {
      theme: {
        'data-bg': 'var(--color-brand-primary)',
        'data-color': 'var(--color-brand-foreground)',
        'data-highlight': 'var(--color-white)',
        'data-highlight-color': 'var(--color-secondary)',
        'data-start': 'complete',
        'data-scroll-y-start-vh': '0',
        'data-scroll-y-span-vh': '80',
        'data-scroll-y-start-offset': '40',
        'data-scroll-y-reverse': 'true',
        'data-header-fade': 'true',
      },
      scroll: heroScroll,
      fixed: heroFixed,
    },
    introMotion: {
      scroll: introScroll,
      fixed: introFixed,
    },
    explain: [
      explainSection(
        'case-page0',
        'Objectives',
        [
          { title: 'Unconventional, but intuitive', body: "Onmo's intentionally unconventional brand needed to extend naturally into the app and web experience, retaining its distinctive character without compromising usability or accessibility." },
          { title: 'Create consistency at scale', body: 'Establish a shared design system that brings greater consistency to the product while providing clear patterns for new journeys, features and experiences.' },
          { title: 'Make credit feel straightforward', body: 'Create a clear and intuitive experience that makes managing credit simple to understand, reducing complexity across everyday tasks and key financial decisions.' },
        ],
        { src: projectVideo('onmo', 'feet.mp4') },
        { themeScroll: false, dividerStyle: { '--divider-bg': 'var(--color-brand-foreground)', '--divider-opacity': 0.2 } },
      ),
      explainSection(
        'case-page1',
        'Key insights',
        [
          { title: 'Credit has a learning curve', body: 'For people new to credit cards, familiar financial terminology and conventions can\'t be taken for granted. The experience needs to explain how credit works clearly, without overwhelming users with unnecessary complexity.' },
          { title: 'Complexity erodes confidence', body: 'Credit products can quickly become difficult to understand. Clear information, transparent interactions and familiar patterns are essential for helping customers understand their position and make informed decisions.' },
          { title: 'Conventional is forgettable', body: 'Credit cards operate in a crowded and often visually similar market. Creating a distinctive experience gives Onmo a better chance of being noticed, remembered and understood as a different kind of provider.' },
        ],
        { src: projectVideo('onmo', 'shopping.mp4') },
        { themeScroll: false, dividerStyle: { '--divider-bg': 'var(--color-brand-foreground)', '--divider-opacity': 0.2 } },
      ),
    ],
    outcomes: [
      {
        index: '01',
        title: 'A distinctive digital experience',
        body: 'The refreshed brand was carried through the app and web experience, giving Onmo a more recognisable presence while keeping everyday interactions clear and intuitive.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-6/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-6/12 content-center',
        scroll: {
          'data-scroll-y-start-vh': '0',
          'data-scroll-y-span-vh': '100',
          'data-scroll-y-start-offset': '-10rem|0',
          'data-scroll-y-reverse': 'true',
          'data-scroll-y-factor': '1.5|1.3',
        },
        media: {
          containerClass: 'device-container',
          devices: [
            {
              type: 'ipad',
              wrapperClass: 'ipad animate-screen',
              images: [{ src: projectImage('onmo', 'desktop-home.jpg') }],
            },
          ],
        },
      },
      {
        index: '02',
        reverse: true,
        title: 'Credit made easier to understand',
        body: 'Clearer journeys, language and information helped make credit more approachable for people with limited experience of using or managing a credit card.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-5/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-7/12 content-center content-visible relative',
        media: {
          containerClass: 'device-container iphone-reveal center',
          devices: [
            {
              type: 'iphone',
              wrapperClass: 'iphone iphone-reveal-static z-2',
              screenClass: 'no-safe-area',
              images: [{ src: projectImage('onmo', 'mobile-statement.jpg') }],
            },
            {
              type: 'iphone',
              wrapperClass: 'iphone iphone-reveal-left slide',
              screenClass: 'no-safe-area',
              images: [{ src: projectImage('onmo', 'mobile-spend.jpg') }],
            },
          ],
        },
      },
      {
        index: '03',
        title: 'Greater consistency at scale',
        body: 'A shared design system brought greater consistency across products and journeys, providing a common foundation for the experience as Onmo continued to grow.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-6/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-6/12 content-center',
        scroll: {
          'data-scroll-y-start-vh': '0',
          'data-scroll-y-span-vh': '100',
          'data-scroll-y-start-offset': '-10rem|0',
          'data-scroll-y-reverse': 'true',
          'data-scroll-y-factor': '1.5|1.3',
        },
        media: {
          containerClass: 'device-container',
          devices: [
            {
              type: 'ipad',
              wrapperClass: 'ipad animate-screen',
              images: [{ src: projectImage('onmo', 'desktop-design-system.jpg') }],
            },
          ],
        },
      },
      {
        index: '04',
        reverse: true,
        title: 'Bold, but usable',
        body: 'The expressive visual direction was balanced with clear hierarchy, legible content and intuitive interactions, allowing the product to feel unconventional without becoming difficult to use.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-6/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-6/12 content-center',
        scroll: {
          'data-scroll-y-start-vh': '-12|-30|-10',
          'data-scroll-y-span-vh': '100',
          'data-scroll-y-start-offset': '10|0',
          'data-scroll-y-reverse': 'true',
          'data-scroll-y-factor': '1.1|1.3|1.4',
        },
        media: {
          containerClass: 'device-container',
          devices: [
            {
              type: 'iphone',
              wrapperClass: 'iphone animate-screen',
              screenClass: 'no-safe-area',
              images: [{ src: projectImage('onmo', 'mobile-account.jpg') }],
            },
          ],
        },
      },
    ],
  },
  {
    slug: 'clim8',
    title: 'Clim8 Invest',
    shortTitle: 'Clim8',
    path: '/projects/clim8',
    published: true,
    seo: {
      title: 'Clim8 Invest | mustimpress.com',
      description: 'A sustainable investment app for a pioneering climate fintech startup.',
    },
    brand: {
      primary: '#31C4A8',
      foreground: '#000033',
      introColor: 'var(--color-brand-foreground)',
      introHighlight: 'var(--color-black)',
      explainColor: 'var(--color-brand-foreground)',
      explainHighlight: 'var(--color-black)',
      hue: 10,
    },
    tags: ['UX', 'UI', 'Accessibility'],
    caseTags: ['UX', 'UI', 'Accessibility'],
    homeTags: ['UX', 'UI', 'Accessibility'],
    intro: 'A sustainable investment app for a pioneering climate fintech startup.',
    cover: {
      tile: 'device',
      fg: projectImage('clim8', 'cover-fg.png'),
      bg: projectImage('clim8', 'cover-bg.jpg'),
      alt: 'Clim8',
      device: {
        type: 'iphone',
        screenClass: 'no-safe-area',
        images: [{ src: projectImage('clim8', 'mobile-dashboard.jpg') }],
      },
    },
    overview: {
      context: 'Overview',
      title: 'UX, UI & Accessibility',
      body: "I helped shape Clim8's investment app through accessible UI design and a scalable design system, simplifying complex financial journeys while bringing greater consistency across the product.",
      logo: projectImage('clim8', 'logo-clim8.png'),
    },
    hero: {
      theme: {
        'data-bg': 'var(--color-brand-primary)',
        'data-color': 'var(--color-brand-foreground)',
        'data-highlight': 'var(--color-white)',
        'data-highlight-color': 'var(--color-secondary)',
        'data-start': 'complete',
        'data-scroll-y-start-vh': '0',
        'data-scroll-y-span-vh': '80',
        'data-scroll-y-start-offset': '40',
        'data-scroll-y-reverse': 'true',
        'data-header-fade': 'true',
      },
      scroll: heroScroll,
      fixed: heroFixed,
    },
    introMotion: {
      scroll: introScroll,
      fixed: introFixed,
    },
    explain: [
      explainSection(
        'case-page0',
        'Objectives',
        [
          { title: 'Make green investing easy', body: 'Create a clear and intuitive experience that makes investing simple to understand and navigate, removing unnecessary complexity while supporting users throughout their investment journey.' },
          { title: 'Build trust through design', body: "Balance Clim8's distinctive, optimistic brand with the clarity and credibility expected from an investment platform, creating an experience that feels both engaging and trustworthy." },
          { title: 'Design for growth', body: 'Establish a consistent and flexible experience that could accommodate new investment journeys, content and features as the product continued to grow.' },
        ],
        { src: projectVideo('clim8', 'wind.mp4'), className: 'square' },
        { themeScroll: false, dividerStyle: { '--divider-bg': 'var(--color-brand-foreground)', '--divider-opacity': 0.2 } },
      ),
      explainSection(
        'case-page1',
        'Key insights',
        [
          { title: 'Simplicity builds confidence', body: 'Investing can feel complex and intimidating, particularly for less experienced investors. Clear language, familiar patterns and simple interactions help make decisions feel more manageable.' },
          { title: 'Finance and purpose must coexist', body: 'Clim8 needed to express its strong environmental purpose without losing the credibility expected of a financial product. The experience had to feel optimistic, but considered and trustworthy.' },
          { title: 'Impact needs to feel tangible', body: 'Sustainable investing can feel abstract. Showing where money is invested and the impact those investments support helps make the connection between financial decisions and climate goals more tangible.' },
        ],
        { src: projectVideo('clim8', 'solar.mp4') },
        { themeScroll: false, dividerStyle: { '--divider-bg': 'var(--color-brand-foreground)', '--divider-opacity': 0.2 } },
      ),
    ],
    outcomes: [
      {
        index: '01',
        reverse: true,
        title: 'Brand and product aligned',
        body: 'Bringing the refreshed identity into the app created a more cohesive experience, with the brand expressed consistently across both the product and wider digital touchpoints.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-5/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-7/12 content-center content-visible relative',
        media: {
          containerClass: 'device-container iphone-reveal center',
          devices: [
            {
              type: 'iphone',
              wrapperClass: 'iphone iphone-reveal-static z-2',
              screenClass: 'no-safe-area',
              images: [{ src: projectImage('clim8', 'mobile-impact.jpg') }],
            },
            {
              type: 'iphone',
              wrapperClass: 'iphone iphone-reveal-left slide',
              screenClass: 'no-safe-area',
              images: [{ src: projectImage('clim8', 'mobile-impact-community.jpg') }],
            },
          ],
        },
      },
      {
        index: '02',
        title: 'A foundation for growth',
        body: 'A Design System of reusable patterns and components made it easier to introduce new journeys, content and interactive features while maintaining consistency across the product.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-6/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-6/12 content-center content-visible relative',
        scroll: {
          'data-scroll-y-start-vh': '0',
          'data-scroll-y-span-vh': '100',
          'data-scroll-y-start-offset': '-10rem|0',
          'data-scroll-y-reverse': 'true',
          'data-scroll-y-factor': '1.5|1.3',
        },
        media: {
          containerClass: 'device-container',
          devices: [
            {
              type: 'ipad',
              wrapperClass: 'ipad animate-screen',
              images: [{ src: projectImage('clim8', 'desktop-design-system.jpg') }],
            },
          ],
        },
      },
      {
        index: '03',
        title: 'A more accessible experience',
        body: 'Refining the brand and interface for accessibility created a more inclusive and polished experience while retaining the distinctive visual character of Clim8.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-6/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-6/12 content-center',
        scroll: {
          'data-scroll-y-start-vh': '0',
          'data-scroll-y-span-vh': '100',
          'data-scroll-y-start-offset': '-10rem|0',
          'data-scroll-y-reverse': 'true',
          'data-scroll-y-factor': '1.5|1.3',
        },
        media: {
          containerClass: 'device-container',
          devices: [
            {
              type: 'ipad',
              wrapperClass: 'ipad animate-screen',
              images: [{ src: projectImage('clim8', 'desktop-accessibility.jpg') }],
            },
          ],
        },
      },
      {
        index: '04',
        reverse: true,
        title: 'A simpler investment journey',
        body: 'Clearer journeys and intuitive interactions made investing easier to understand and navigate, reducing complexity across key moments in the experience.',
        textClass: 'w-full md:w-1/3 lg:w-1/3 xl:w-6/12 content-center',
        mediaClass: 'w-full md:w-2/3 lg:w-2/3 xl:w-6/12 content-center',
        scroll: {
          'data-scroll-y-start-vh': '-12|-30|-5',
          'data-scroll-y-span-vh': '100',
          'data-scroll-y-start-offset': '10|0',
          'data-scroll-y-reverse': 'true',
          'data-scroll-y-factor': '1.1|1.3|1.4',
        },
        media: {
          containerClass: 'device-container',
          devices: [
            {
              type: 'iphone',
              wrapperClass: 'iphone animate-screen',
              screenClass: 'no-safe-area',
              ui: [{ className: 'footer', src: projectImage('clim8', 'mobile-menubar.jpg') }],
              images: [{ src: projectImage('clim8', 'mobile-dashboard.jpg') }],
            },
          ],
        },
      },
    ],
  },
  {
    slug: 'halifax',
    title: 'Halifax',
    published: false,
    tags: ['UI'],
    homeTags: ['UI'],
    cover: {
      tile: 'device',
      bg: projectImage('halifax', 'cover-bg.jpg'),
      alt: 'Halifax',
      device: {
        type: 'iphone',
        screenClass: 'no-safe-area',
        ui: [{ className: 'footer', src: projectImage('halifax', 'mobile-menubar.jpg') }],
        images: [{ src: projectImage('halifax', 'mobile-accounts.jpg') }],
      },
    },
  },
  {
    slug: 'propa',
    title: 'Propa',
    published: false,
    tags: ['Product Design', 'Branding', 'UX', 'UI', 'Web Dev'],
    homeTags: ['Product Design', 'Branding', 'UX', 'UI', 'Web Dev'],
    cover: {
      tile: 'device',
      bg: projectImage('propa', 'cover-bg.jpg'),
      alt: 'Propa',
      device: {
        type: 'iphone',
        screenStyle: { '--safe-area-bg': '#FFF' },
        images: [{ src: projectImage('propa', 'mobile-workspace.jpg') }],
      },
    },
  },
];

export function getPublishedProjects() {
  return projects.filter((project) => project.published);
}

export function getProjectBySlug(slug) {
  return projects.find((project) => project.slug === slug);
}

export const routes = [
  '/',
  ...getPublishedProjects().map((project) => project.path),
];
